export default "__VITE_ASSET__dc841ba7__"